import Vue from 'vue';
import router from '~/router.js';
import store from '~/store.js';
import mainLayout from '../layout/index.vue';
import { applyPlugin, applyAsyncPlugin } from '~/lib.js';

Vue.config.devtools = process.env.NODE_ENV !== 'production';
const initOptions = {
  render: h => h(mainLayout),
  router: router,
  store: store
};

let app;

start();

async function start() {
  await applyAsyncPlugin('beforeAppCreate', initOptions);
  addHook(initOptions, 'beforeDestroy', () =>
    applyPlugin('beforeAppDestroy', app, initOptions)
  );
  addHook(initOptions, 'mounted', () =>
    applyPlugin('appMounted', app, initOptions)
  );
  app = new Vue(initOptions);
  await applyAsyncPlugin('beforeAppMount', app, initOptions);
  app.$mount('#app');
}

function addHook(option, key, cb) {
  const originHook = option[key];
  option[key] = originHook
    ? Array.isArray(originHook)
      ? originHook.push(cb) && originHook
      : [originHook, cb]
    : [cb];
}

export default app;
